import { render } from "./OnboardingWizard.vue?vue&type=template&id=83ec4056&scoped=true"
import script from "./OnboardingWizard.vue?vue&type=script&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&lang=js"

import "./OnboardingWizard.vue?vue&type=style&index=0&id=83ec4056&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ec4056"]])

export default __exports__